import { useEffect } from 'react';
import { applyDocumentHeadTitle } from '@/utils/documentHeadTitle';

/**
 * Synchronizes the head title element when the view mounts.
 * Cleanup restores the previous title (e.g. when returning to the main app shell).
 */
export function useDocumentHeadTitle(title: string): void {
  useEffect(() => {
    const restore = applyDocumentHeadTitle(title);
    return restore;
  }, [title]);
}
